import PropTypes from 'prop-types'
import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import ProgressCard from '../../../../components/card/ProgressCard'
import Button from '../../../../components/forms/Button'
import Input from '../../../../components/forms/Input'
import Icon from '../../../../components/icon/Icon'
import Job from '../../../dto/DtoJob'
import { Grid } from '@mui/material'

class VeoliaPortalPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataLoaded: true,
            progress: 0,
            fileName: '',
        }
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}

    render() {
        if (this.state.dataLoaded) {
            const disabled = !this.props.isEditMode
            const filters = this.getFilters()
            const files = filters.fileNames || []
            return (
                <div>
                    <Grid container sx={{ alignItems: 'center' }}>
                        <Grid size={12}>
                            <fieldset className='width-100'>
                                <legend>&nbsp;{ 'Identifiants portail Veolia' }&nbsp;</legend>
                                <Grid container spacing={1}>
                                    <Grid size={4}>
                                        <Input title={ i18n.login } onChange={ v => this.onChangeFilters({ portalUser: v }) } disabled={ disabled } value={ filters.portalUser } />
                                    </Grid>
                                    <Grid size={4}>
                                        <Input title={ i18n.password } onChange={ v => this.onChangeFilters({ portalPassword: v }) } disabled={ disabled } value={ filters.portalPassword } passwordType/>
                                    </Grid>
                                    <Grid size={5}>
                                        <Input title={ 'Répertoire FTP' } onChange={ v => this.onChangeFilters({ directory: v }) } disabled={ disabled } value={ filters.directory } />
                                    </Grid>
                                </Grid>
                            </fieldset>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ paddingTop: 1 }}>
                        <Grid size={12}>
                            <fieldset className='width-100'>
                                <legend>&nbsp;{ 'Choix des fichiers à récupérer' }&nbsp;</legend>
                                <Grid container spacing={1}>
                                    <Grid size={5}>
                                        <Input title={ i18n.fileName } onChange={ v => this.setState({ fileName: v }) } disabled={ disabled } value={ this.state.fileName } />
                                    </Grid>
                                    <Grid size={2}>
                                        <Button icon='note_add' className='width-100' title={ i18n.add } disabled={ disabled } onClick={ () => {
                                            if (this.state.fileName && this.state.fileName.length) {
                                                this.onChangeFilters({ fileNames: [...files, this.state.fileName] })
                                                this.setState({ fileName: '' })
                                            }
                                        } }
                                        />
                                    </Grid>
                                    <Grid size={5}/>
                                </Grid>

                            </fieldset>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ paddingTop: 1 }}>
                        <Grid size={12}>
                            {
                                files.map(f => (
                                    <Grid container>
                                        <Grid size={1}><Icon icon='clear' onClick={ () => this.onChangeFilters({ fileNames: files.filter(f2 => f2 !== f) }) } /></Grid>
                                        <Grid size={11}><h6>{ f }</h6></Grid>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>
                </div>
            )
        }
        return <ProgressCard progress={ this.state.progress }/>
    }
}

VeoliaPortalPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeJob: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
}

export default VeoliaPortalPanel